import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import InventoryListPopupStudent from './InventoryListPopupStudent';
import StudentListPopup from './StudentListPopup';
import './styles/TransferInventoryPage.css';
import { BsFiles } from "react-icons/bs";
import { MdDelete } from "react-icons/md";
import { useNavigate } from 'react-router-dom'; 
import { generatePaymentReceiptPDF } from './util/paymentReceipt';

const StudentPurchasePage = () => {
    const [branchList, setBranchList] = useState([]);
    const [branch, setBranch] = useState('');
    const [receiver, setReceiver] = useState(null);
    const [items, setItems] = useState([]);
    const [showInventoryPopup, setShowInventoryPopup] = useState(false);
    const [showStudentPopup, setShowStudentPopup] = useState(false);
    const navigate = useNavigate();
    const [paymentDate, setPaymentDate] = useState('');
    const [paymentAmount, setPaymentAmount] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('');
    
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const fetchBranchList = async () => {
            try {
                const response = await api.get('/utils/getBranchList');
                const branches = response.data.data.branchList.map(branch => ({
                    id: branch.branch_id,
                    name: `${branch.branch_code} - ${branch.branch_name}`,
                }));
                setBranchList(branches);
            } catch (error) {
                console.error("Failed to fetch branch list", error);
            }
        };

        fetchBranchList();
        
    }, []);

    const validateForm = () => {
        const errors = {};
    
        // Cek jika field kosong
        
        if (!paymentMethod) errors.payment_method = 'Payment Method is required';
        if (!receiver) errors.receiver = 'Student is required';
        if (!paymentDate) errors.paymentDate = 'Payment Date is required';
        
        return errors;
    };

    const formatNumber = (number) => {
        return Number(number).toLocaleString('id-ID', { maximumFractionDigits: 0 });
    };

    const calculateTotalHarga = () => {    
        const totalInventory = items.reduce((total, item) => {
          return item.price !== 0 ? total + Number(item.price) : total;
        }, 0);
        //setPaymentAmount(totalInventory);
        return totalInventory;
    };

    const handleSelectItem = (selectedItems) => {
        const newItems = selectedItems.filter(selectedItem => 
            !items.some(item => item.inventory_id === selectedItem.inventory_id)
        );
    
        if (newItems.length > 0) {
            setItems((prevItems) => [...prevItems, ...newItems]);
        } 
    };

    const handleSelectStudent = (student) => {
        setReceiver(student);
        setShowStudentPopup(false);
    };

    const handleSubmit = async () => {

        
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }

            const paymentData = {
                paymentMethod: paymentMethod,
            };
        
            const paymentDetails = items.map((item) => ({
                item: item.item_name,
                amount: item.price,
            }));
        
            const purchaseData = {
                data: {
                    student_id: receiver.student_id,
                    inventoryData: items.map(item => ({
                        inventory_id: item.inventory_id,
                        price: item.price,
                    })),
                    paymentData: {
                        payment_date: paymentDate,  // Set as today’s date
                        payment_amount: calculateTotalHarga(),  // Total payment calculated
                        payment_method: paymentMethod
                    }
                },
            };

        
            try {
                const response = await api.post('/student/purchase/save', purchaseData); 
                const successMessage = response.data.message;
                console.log(successMessage);
                setItems([]);
                setReceiver(null);
                setBranch('');
                generatePaymentReceiptPDF(receiver, paymentData, paymentDetails, paymentDate, 'MODUL');
                navigate('/success', { state: { message: successMessage } });
                
            } catch (error) {
                console.error('Error submitting data:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            }
        }


        
    };
  
    const handleDeleteItem = (index) => {
        const newItems = items.filter((_, i) => i !== index);
        setItems(newItems);
    };

  return (
    <div className="transfer-inventory-page">
        <div className="page-title">Student Purchase</div>
        <div className="form-container">
            <div className="section">
                <div className="search-container">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <label>Branch</label>
                                </td>
                                <td>
                                    <select value={branch} onChange={(e) => setBranch(e.target.value)}>
                                        <option value="">Select Branch</option>
                                        {branchList.map(branch => (
                                            <option key={branch.id} value={branch.id}>
                                                {branch.name}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Student Name</label>
                                </td>
                                <td>
                                    <div className="input-container">
                                    <input type="text" value={receiver ? receiver.student_name : ''} readOnly />
                                        <BsFiles className="icon" onClick={() => setShowStudentPopup(true)} />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Add Item</label>
                                </td>
                                <td>
                                    <div className="input-container">
                                        <BsFiles className="icon" onClick={() => setShowInventoryPopup(true)} />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="section">
                <div className="inventory-list">
                    <table>
                        <thead>
                            <tr>
                                <th class="no-column">No</th>
                                <th>Item Name</th>
                                <th>Item Type</th>
                                <th>Price</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.item_name}</td>
                                    <td>{item.item_type}</td>
                                    <td>{formatNumber(item.price)}</td>
                                    <td>
                                        <MdDelete className="icon" onClick={() => handleDeleteItem(index)} />  
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <td colSpan="3"><strong>Total Pembayaran</strong></td>
                                <td className='table-right-align'><strong>{formatNumber(calculateTotalHarga())}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="section">
                <h3 className="section-header">Payment Data</h3>
                <div className="search-container">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <label>Payment Amount</label>
                                </td>
                                <td>
                                    <input 
                                        type="number"     
                                        value={formatNumber(calculateTotalHarga())}  
                                        readOnly/>
                                </td>
                            </tr>
                            <tr>
                                {errors.paymentAmount && 
                                <td>
                                    <div className="error-message">{errors.paymentAmount}</div>
                                </td>
                                }
                            </tr>
                            <tr>
                                <td>
                                    <label>Payment Date</label>
                                </td>
                                <td>
                                    <input type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                                </td>
                            </tr>
                            <tr>
                                {errors.paymentDate && 
                                <td>
                                    <div className="error-message">{errors.paymentDate}</div>
                                </td>
                                }
                            </tr>
                            <tr>
                                <td>
                                    <label>Payment Method</label>
                                </td>
                                <td>
                                    <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} >
                                        <option key="" value="">Choose Payment Method</option>
                                        <option key="BANK BCA" value="BANK BCA">BANK BCA</option>
                                        <option key="BANK BRI" value="BANK BRI">BANK BRI</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                {errors.payment_method && 
                                <td>
                                    <div className="error-message">{errors.payment_method}</div>
                                </td>
                                }
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="search-container">
                    <button className="profile-button" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </div>
        {showInventoryPopup && (
            <InventoryListPopupStudent onSelectItems={handleSelectItem} onClose={() => setShowInventoryPopup(false)} />
        )}

        {showStudentPopup && (
            <StudentListPopup 
            onSelectStudent={handleSelectStudent} 
            onClose={() => setShowStudentPopup(false)} 
            branchId={branch} 
            />
        )}
    </div>
  );
};

export default StudentPurchasePage;
